import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { passwordMatchValidator } from '@app/_helpers/passwordValidator';
import { AutomationRequest } from '@app/_models/automationRequest';
import { RequestStatus, User, UserDetail } from '@app/_models/user';
import { AlertService, AutomationService } from '@app/_services';
import { AccountService } from '@app/_services/account.service';
import { first } from 'rxjs/internal/operators/first';

@Component({
  selector: 'app-user-validate',
  templateUrl: './user-validate.component.html',
  styleUrls: ['./user-validate.component.less']
})
export class UserValidateComponent implements OnInit {
  userDetail:UserDetail;
  rgFrmGrp: FormGroup;
  minPw = 8;
  msg="";
  isLoading = false;
  inProcess = false;
  isNew=false;
  requestStatus=RequestStatus;

  constructor(
    private formBuilder: FormBuilder,
    private automationService: AutomationService,
    private accountService: AccountService,
    private acRouter: ActivatedRoute,
    private router: Router,
    private alertService: AlertService
  ) { 
    this.createForm();
  }

  ngOnInit(): void {
      this.isLoading=true;
      const reqId = this.acRouter.snapshot.paramMap.get('reqId');
      this.accountService.getByUID(reqId).subscribe((user:UserDetail)=>{
        
          if(user!=null && user.requestStatus==RequestStatus.Pending){
            this.isNew=true;
            this.isLoading=false;
            this.userDetail=user;
            this.patchForm(user);
          }else{
            this.isNew=false;
            this.router.navigate(['./account/login']);
          }
          
          
      })
  }
  createForm(){
    this.rgFrmGrp = this.formBuilder.group({
      name: [{value:"", disabled: true}, [Validators.required]],
      emailId: [{value:"", disabled: true}, Validators.compose([Validators.required,Validators.email])],
      companyName: [{value:"", disabled: true}, [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(this.minPw)]],
      confirmPassword: ['', [Validators.required]],},{ validator: passwordMatchValidator });
  }
  patchForm(user:UserDetail){
    this.rgFrmGrp = this.formBuilder.group({
      name: [{value:user.name, disabled: true}, [Validators.required]],
      emailId: [{value:user.emailId, disabled: true}, Validators.compose([Validators.required,Validators.email])],
      companyName: [{value:user.companyName, disabled: true}, [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(this.minPw)]],
      confirmPassword: ['', [Validators.required]],},{ validator: passwordMatchValidator });
  }


  /* Shorthands for form controls (used from within template) */
  get newPassword() { return this.rgFrmGrp.get('newPassword'); }
  get confirmPassword() { return this.rgFrmGrp.get('confirmPassword'); }
  get f() { return this.rgFrmGrp.controls; }

  /* Called on each input in either password field */
  onPasswordInput() {
    if (this.rgFrmGrp.hasError('passwordMismatch'))
      this.confirmPassword.setErrors([{ 'passwordMismatch': true }]);
    else
      this.confirmPassword.setErrors(null);
  }

  onSubmitMemberInfo() {
    if (this.rgFrmGrp.valid) {
        this.inProcess = true;
        const frm = this.rgFrmGrp.value;
        const payLoad={
          password:frm.newPassword,
          userUID:this.userDetail.uid,
          name:this.userDetail.name,
          companyName:this.userDetail.companyName,
          emailId:this.userDetail.emailId
        }

        this.accountService.createUserFromRequest(payLoad).subscribe((result:boolean) => {
          this.inProcess = false;
          if (result && result==true) {
            this.rgFrmGrp.reset();
            this.isNew = false;
            this.alertService.success('Request created successfully', { keepAfterRouteChange: true });
            this.onLogin(payLoad.emailId,payLoad.password);
          } else {
            this.msg = "Something went wrong";
          }
        }, error => {
          this.inProcess = false;
        })
    }
  }

  onLogin(username:string, password:string){
    localStorage.clear();
    this.accountService.login(username,password).pipe(first())
    .subscribe(data=>{
      if (data && data.isSuccess==true) {
        this.router.navigate([`./connection/automation/${data.uId}`]);
      } else {
        this.alertService.error(data.message);
      }
    })
  }
}
